module.exports = __webpack_public_path__ + "static/media/diamond.26d1037c.svg";